import { catalogueStickerUrl } from "@listou/shared/stickers";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";

import { GuideShelves, ListCallout } from "../components/gift-guide";
import { Sticker } from "../components/list-page/parts";
import { SiteFooter, SiteHeader } from "../components/site-header";
import { Spinner } from "../components/ui/spinner";
import { GIFT_GUIDE_PAGES } from "../lib/gift-guides";
import { seo } from "../lib/head";
import { catalogueCategoriesQuery } from "../lib/queries";
import { viewerQuery } from "../lib/session";

const guide = GIFT_GUIDE_PAGES.birth;

export const Route = createFileRoute("/idees-cadeaux-naissance/")({
  staticData: { ssr: true },
  loader: ({ context: { queryClient } }) =>
    queryClient.prefetchQuery(catalogueCategoriesQuery("birth")),
  head: () => seo({ title: guide.seoTitle, description: guide.seoDescription }),
  component: GuideHub,
});

function GuideHub() {
  const viewer = useQuery({ ...viewerQuery, retry: false });
  const categories = useQuery(catalogueCategoriesQuery("birth"));
  return (
    <div className="min-h-dvh">
      <SiteHeader signedIn={viewer.isSuccess} />
      <main className="mx-auto grid max-w-6xl gap-10 px-4 pt-6 pb-20 sm:px-6">
        <nav aria-label="Fil d'Ariane" className="text-muted">
          <Link to="/idees-cadeaux" className="font-bold hover:underline">
            Idées cadeaux
          </Link>
          <span aria-hidden> › </span>
          <span>Naissance</span>
        </nav>
        <header className="grid items-center gap-6 sm:grid-cols-[1fr_auto]">
          <div className="grid max-w-3xl gap-3">
            <h1 className="text-5xl font-medium sm:text-6xl">{guide.h1}</h1>
            <p className="text-xl text-ink/80">{guide.intro}</p>
          </div>
          <div className="row-start-1 flex sm:col-start-2" aria-hidden>
            <Sticker src={catalogueStickerUrl("doudous")} className="w-24 -rotate-6 sm:w-36" />
            <Sticker src={catalogueStickerUrl("cadeau")} className="-ml-6 w-20 rotate-6 sm:w-28" />
          </div>
        </header>
        {categories.isPending && <Spinner className="size-8 justify-self-center" />}
        {categories.isError && (
          <p className="text-danger">
            Les rayons n'ont pas pu être chargés. Réessayez dans un instant.
          </p>
        )}
        {categories.data && <GuideShelves guide={guide} categories={categories.data.categories} />}
        <ListCallout />
      </main>
      <SiteFooter />
    </div>
  );
}
